// extracted by mini-css-extract-plugin
export default {"root":"FooterLeft_root__mh6VE","link":"FooterLeft_link__SoFlx"};